import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(shop)/quiz/page.tsx");
